<template>
  <span v-if="Object.keys(events).length > 0">
    <article
      @click="navigateToEvent(event)"
      v-for="(event, i) in events"
      :key="event.id"
      :class="`event-item ${!recent && 'upcoming'} ${
        index === Object.keys(events).length - 1 ? 'no-border' : ''
      }`"
      :style="`border-left: ${
        borderColors[i % borderColors.length]
      } 0.3em solid`"
    >
      <div class="media-content">
        <div class="content pd-font">
          <p>
            <span class="pd-font uppercase spacing">
              <strong>{{ event.title }} </strong></span
            >
            <br />
            <small>
              {{ getMoment(event.date) }}
              <span v-if="event.address.room.length > 0"
                >| <i class="fas fa-map-marker-alt" />
                {{ event.address.room }}</span
              >
              <br />
              <span
                v-if="!recent"
                :class="
                  event.form && event.form.settings.accessible
                    ? `has-text-success`
                    : ''
                "
                >{{
                  event.form && event.form.settings.accessible
                    ? "Sign up now"
                    : ""
                }}</span
              >
            </small>
          </p>
        </div>
      </div>
    </article>
  </span>
  <span v-else-if="!recent"
    >There are no upcoming events at this time. Be on the lookout for events on
    our social media!</span
  >
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import _ from "lodash";
export default {
  props: {
    recent: {
      type: Boolean,
      default: false,
    },
    borderColors: {
      type: Array,
      default: () => ["#ffd96a", "#182c61", "#ef9bc1", "#d2eadf", "#f4ad42"],
    },
  },
  data() {
    return {
      renderNoEvents: [],
    };
  },
  methods: {
    navigateToEvent(event) {
      if (!this.recent) {
        this.$ga.event("Event list", "Navigated", "to", event.title);
        this.$router.push(`/event/${event.id}`);
      }
    },
    getBool(date, formID) {
      const form = this.$route.params.formID
        ? formID !== this.$route.params.formID
        : true;
      const event = this.$route.params.eventID
        ? formID !== this.$route.params.eventID
        : true;
      const bool = Date.now() < date * 1000 && form && event;
      return bool;
    },
    getMoment(timestamp) {
      return moment(timestamp.toDate()).format(
        this.recent ? "D MMMM YYYY" : "D MMMM YYYY HH:mm"
      );
    },
  },
  computed: {
    ...mapState({
      events: function (state) {
        const { events } = state.content;
        const list = {};
        Object.values(events).some((event) => {
          const upcoming = this.getBool(event.date.seconds, event.id);
          if (
            event.public &&
            ((upcoming && !this.recent) || (!upcoming && this.recent))
          ) {
            list[event.id] = event;
          }
          // If displaying recent events, only the latest 3 are shown
          return this.recent && Object.entries(list).length > 2;
        });
        return _.orderBy(list, "date", this.recent ? "desc" : "asc");
      },
    }),
  },
  beforeCreate() {
    this.$store.dispatch("content/fetchEvents");
  },
};
</script>

<style scoped>
.event-item {
  margin-top: 0;
  padding: 2rem;
  transition: transform 0.2s;
  border-bottom: #d8d8d8 0.5px solid;
}
.event-item.upcoming:hover {
  transform: scale(1.03);
  cursor: pointer;
}
.event-item.no-border {
  border-bottom: none !important;
}
.event-item i {
  color: #c0c0c0;
}
</style>
